import { BaseSkeleton } from 'components/BaseSkeleton'

import './modal-documents.styles.scss'

const DocumentListItemSkeleton = () => (
  <BaseSkeleton.Theme baseColor="var(--color_neutral_700)" highlightColor="var(--color_neutral_600)">
    <div className="ModalDocuments-listItem">
      <div className="UploadListItem">
        <div className="UploadListItem-column" style={{ minWidth: '20px' }}>
          <BaseSkeleton width={20} height={20} circle />
        </div>

        <div className="UploadListItem-column" style={{ width: '100%', flex: 1 }}>
          <BaseSkeleton width="70%" height={14} containerClassName="UploadListItem-skeleton-container" />
        </div>

        <div className="UploadListItem-column right" style={{ minWidth: '40px' }}>
          <BaseSkeleton width={40} height={14} />
        </div>

        <div className="UploadListItem-column" style={{ minWidth: '50px' }}>
          <BaseSkeleton width={50} height={14} />
        </div>

        <div className="UploadListItem-column right" style={{ minWidth: '145px' }}>
          <BaseSkeleton width={145} height={14} />
        </div>

        <div className="UploadListItem-column right" style={{ minWidth: '20px' }}>
          <BaseSkeleton width={20} height={20} circle />
        </div>
      </div>
    </div>
  </BaseSkeleton.Theme>
)

export const DocumentListSkeleton = () => (
  <>
    {Array.from({ length: 5 }).map((_, index) => (
      <DocumentListItemSkeleton key={`skeleton-${index}`} />
    ))}
  </>
)
